export default "__VITE_ASSET__27daf57a__"